import { Quote, Star } from "lucide-react";
import Reveal from "./Reveal";
import { useT } from "../../i18n/I18nContext";

export const Testimonials = () => {
  const t = useT();
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB]">
              {t.testimonials.eyebrow}
            </p>
          </Reveal>
          <Reveal delay={60}>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A2342] tracking-tight leading-[1.1]">
              {t.testimonials.title}
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {t.testimonials.items.map((tm, i) => (
            <Reveal key={tm.name} delay={80 * i}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="h-full bg-[#F8FAFC] rounded-2xl p-8 border border-slate-200/70 uv-card-hover relative"
              >
                <Quote
                  className="absolute top-7 right-7 w-7 h-7 text-[#2563EB]/15"
                  aria-hidden="true"
                />
                <div className="flex items-center gap-1 text-[#10B981]">
                  {[...Array(5)].map((_, k) => (
                    <Star key={k} className="w-4 h-4 fill-[#10B981]" />
                  ))}
                </div>
                <blockquote className="mt-5 text-[15px] text-slate-700 leading-relaxed">
                  "{tm.quote}"
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3">
                  <span className="inline-flex w-11 h-11 items-center justify-center rounded-full bg-[#0A2342] text-white text-sm font-bold">
                    {tm.initials}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-[#0A2342] leading-tight">
                      {tm.name}
                    </p>
                    <p className="mt-0.5 text-xs text-slate-500">
                      {tm.role} · {tm.business}
                    </p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
